import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { GroceryEvents } from '@/models/grocery';

export const fetchGroceryEvents = async (orderId: string): Promise<GroceryEvents> => {
  const response = await queryExecute({
    query: graphql(`
      query GroceryEvents($orderId: String!) {
        groceryEvents(orderId: $orderId) {
          grocery {
            id
            name
            orderId
            cartId
            orderUUId
            callerId
            customerName
            timeZone
            email
            address
            status
            currency
            notes
            orderNotes
            transactionId
            instruction
            userId
            orderedByName
            timeReceived
            timeShopping
            timeShoppingComplete
            timeInTransit
            timeCompleted
            timeCanceled
            paidStatus
            canceledBy
            canceledById
            canceledByName
            reasonForCanceling
            noGoGoFee
            noGoGoFeeReason
            tip
            totalCost
            gogoFee
            gogoCost
            discount
            isTipable
            isSavedGrocery
            assignedOperatorId
            isConfirmedAddressAndNotes
            isInteractedWithShopper
            preauthChargeAmount
            driverId
            groceryStoreId
            storeName
            storeLogo
            driverName
            initialEstimateStartAt
            initialEstimateEndAt
            estimateStartAt
            estimateEndAt
            createdAt
            updatedAt
            store {
              id
              name
              slug
              logo
              createdAt
              updatedAt
            }
            driver {
              id
              firstName
              photo
            }
            user {
              id
              firstName
              lastName
              roles
            }
            transaction {
              id
              date
              category
              description
              notes
              currency
              amount
              associatedObjectType
              associatedObjectId
              associatedUserId
              createdAt
              updatedAt
              status
              errorCode
              ipAddress
              ipCountry
              device
              operatingSystem
              browser
            }
          }
          emails {
            id
            userId
            fromEmail
            toEmail
            name
            subject
            messageId
            rideId
            scheduledRideId
            groceryId
            status
            reason
            purpose
            createdAt
            updatedAt
          }
          callLogs {
            id
            callerId
            rideId
            scheduledRideId
            groceryId
            operatorId
            lovedOneId
            fromPhoneNumber
            toPhoneNumber
            callFlow
            purpose
            timeStart
            timeEnd
            waitStart
            waitEnd
            callSid
            notes
            reason
            callerName
            operatorName
            lovedOneName
            timeZone
            qualityAssurance
            hasRecording
            isOnHold
            createdAt
            updatedAt
            callActions {
              callLogId
              userId
              userName
              userType
              action
              timeStart
              waitEnd
              timeEnd
            }
          }
          activities {
            id
            groceryId
            action
            description
            createdAt
            updatedAt
            user {
              id
              firstName
              lastName
              role
            }
          }
          needLoves {
            id
            groceryId
            operatorId
            type
            status
            resolution
            fields {
              name
              value
            }
            comments {
              name
              comment
              createdAt
            }
            createdAt
            updatedAt
            operator {
              id
              firstName
              lastName
            }
          }
        }
      }
    `),
    variables: {
      orderId,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.groceryEvents;
};
